import { gql, useFragment } from "@apollo/client";

// Style
import style from "./content.module.scss";

// Constants
import { contentBlock } from "@/constants/constants";
import { imgFields, videoFields } from "@/constants/gql-fields";

// Components
import Container from "@/components-layout/container/container";
import ModuleSettings from "@/components-modules/module-settings/module-settings";
import ModuleImage from "@/components-modules/module-image/module-image";
import ModuleVideo from "@/components-modules/module-video/module-video";

export default function Content({ module }) {
  // - Fragment
  const { complete, data } = useFragment({
    fragment: Content.fragments.module,
    fragmentName: "ContentFragment",
    from: {
      __typename: module.__typename,
      id: module.id,
    },
  });

  if (!complete) {
    return;
  }

  // -- If Hide Module -- //
  if (data.contentBlockModuleSettings.hideModule) {
    return;
  }

  // - Variables
  const moduleSettings = data.contentBlockModuleSettings;
  const moduleType = data.moduleType;
  const featured = (moduleType === "text" && data.isFeatured) ?? false;

  // Container
  let containerWidth = "";
  if (moduleType === "text" && data.isWide) containerWidth = "wide";
  if ((moduleType === "image" || moduleType === "video") && data.isWide)
    containerWidth = "full";
  let containerAtts = {};
  if (featured) containerAtts["featured"] = "";

  // Image
  const simpleImage = data.simpleImage.simpleImageOnly;
  const simpleImageSize = data.simpleImage.imageHeight;

  // Video
  const videoObject = data.video;

  return (
    <section
      id={moduleSettings.module_id}
      className={`moduleContent ${style.moduleContent} ${
        moduleSettings.classes ? moduleSettings.classes : ""
      }`}
      preset={data.presetModule && data.presetModule[0]}
      data-featured={featured && "true"}
    >
      <ModuleSettings settings={moduleSettings} wide={data.isWide} />

      <Container width={containerWidth} atts={containerAtts}>
        {moduleType === "text" && data.text && (
          <div
            className="moduleText"
            dangerouslySetInnerHTML={{ __html: data.text }}
          ></div>
        )}

        {moduleType === "image" && (
          <ModuleImage
            image={simpleImage}
            heightPercentage={simpleImageSize}
            fit={data.simpleImage.objectFit}
          />
        )}

        {moduleType === "video" && <ModuleVideo video={videoObject} />}
      </Container>
    </section>
  );
}

Content.fragments = {
  module: gql`
    fragment ContentFragment on ${contentBlock} {
      id
      __typename
      presetModule
      moduleType
      isWide
      # Text
      isFeatured
      text
      # Image
      simpleImage {
        imageHeight
        objectFit
        simpleImageOnly {
          ${imgFields}
        }
        simpleImageOnly {
          node {
            altText
            caption
            sourceUrl
          }
        }
      }
      # Video
      video {
        ${videoFields}
      }
      # -- Module General Settings
      contentBlockModuleSettings {
        ...ModSetFragment @unmask(mode: "migrate")
      }
    }
    ${ModuleSettings.fragments.entry}
  `,
};
